import React from 'react'
import { IconWrapper, CharIcon, SvgContainer } from './styles'
import * as MuIcons from '@material-ui/icons'
import { TColor } from '../../tokens/colors'
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined'
import CompareArrowsIcon from '@mui/icons-material/CompareArrows'
import ContactPageOutlinedIcon from '@mui/icons-material/ContactPageOutlined'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined'
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined'
import LinkIcon from '@mui/icons-material/Link'
import LinkOffIcon from '@mui/icons-material/LinkOff'
import MoneyOutlinedIcon from '@mui/icons-material/MoneyOutlined'
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined'
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined'
import PixIcon from '@mui/icons-material/Pix'
import PixOutlinedIcon from '@mui/icons-material/PixOutlined'
import QRCodeOutlineIcon from '@mui/icons-material/QrCodeOutlined'
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined'
import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined'
import RuleIcon from '@mui/icons-material/Rule'
import ShareIcon from '@mui/icons-material/Share'
import SubtitlesOutlinedIcon from '@mui/icons-material/SubtitlesOutlined'
import VpnKeyOutlinedIcon from '@mui/icons-material/VpnKeyOutlined'
import ChecklistIcon from '@mui/icons-material/Checklist'
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined'

interface Props {
  'data-qa'?: string
  color?: TColor
  name?: string
  onClick?: Function
  size?: number
  svg?: object
  style?: object
}

const Icon: React.FC<any> = (props: Props) => {
  const MaterialComponent =
    optionsOfMaterialIcons[props.name] ?? MuIcons[props.name]
  const isCharIcon = Object.keys(optionsOfCharIcons).includes(props.name)
  const dataQa = props['data-qa'] || `icon-${props.name}`

  return (
    <IconWrapper
      color={props.color}
      size={props.size}
      onClick={() => props?.onClick?.()}
      cursor={props?.onClick ? 'pointer' : 'inherited'}
      data-qa={dataQa}
      style={props.style}
    >
      {MaterialComponent && <MaterialComponent />}
      {props.svg && (
        <SvgContainer color={props.color} name={props.name} size={props.size}>
          {props.svg}
        </SvgContainer>
      )}
      {isCharIcon && (
        <CharIcon color={props.color} name={props.name} size={props.size}>
          {optionsOfCharIcons[props.name]}
        </CharIcon>
      )}
    </IconWrapper>
  )
}

Icon.defaultProps = {
  size: 24,
}

export default Icon

//Legacy icon names
const optionsOfMaterialIcons = {
  access_time: MuIcons.AccessTimeOutlined,
  account_balance_wallet: AccountBalanceWalletOutlinedIcon,
  account_box_outlined: MuIcons.AccountBoxOutlined,
  add: MuIcons.AddOutlined,
  arrow_back: MuIcons.ArrowBackOutlined,
  arrow_forward: MuIcons.ArrowForwardIos,
  arrow_upward: MuIcons.ArrowUpwardOutlined,
  arrow: MuIcons.ArrowForward,
  attach_money: MuIcons.AttachMoney,
  autorenew: MuIcons.AutorenewOutlined,
  business_center_outlined: MuIcons.BusinessCenterOutlined,
  calendar_today: MuIcons.CalendarTodayOutlined,
  call_made: MuIcons.CallMade,
  call_received: MuIcons.CallReceived,
  check_circle_outlined: MuIcons.CheckCircleOutlined,
  check_circle: MuIcons.CheckCircle,
  check: MuIcons.CheckOutlined,
  checklist: ChecklistIcon,
  chevron_left: MuIcons.ChevronLeftOutlined,
  chevron_right: MuIcons.ChevronRightOutlined,
  close: MuIcons.CloseOutlined,
  compare_arrows: CompareArrowsIcon,
  contact_page_outlined: ContactPageOutlinedIcon,
  content_copy: ContentCopyIcon,
  dashboard: MuIcons.DashboardOutlined,
  delete_outlined: DeleteOutlinedIcon,
  description: MuIcons.DescriptionOutlined,
  edit_outlined: MuIcons.EditOutlined,
  error_outline: MuIcons.ErrorOutlineOutlined,
  error: MuIcons.Error,
  exit_to_app: MuIcons.ExitToAppOutlined,
  favorite_border_outlined: MuIcons.FavoriteBorderOutlined,
  favorite_outlined: MuIcons.FavoriteOutlined,
  file_copy: FileCopyOutlinedIcon,
  file_download_outlined: FileDownloadOutlinedIcon,
  file_upload_outlined: FileUploadOutlinedIcon,
  filter_list: MuIcons.FilterListOutlined,
  folder_outlined: MuIcons.FolderOutlined,
  get_app: MuIcons.GetApp,
  handshake: HandshakeOutlinedIcon,
  home_outlined: MuIcons.HomeOutlined,
  home: MuIcons.Home,
  info_outlined: MuIcons.InfoOutlined,
  info: MuIcons.Info,
  insert_chart: MuIcons.InsertChartOutlined,
  insert_drive_file: MuIcons.InsertDriveFileOutlined,
  keyboard_arrow_down: MuIcons.KeyboardArrowDownOutlined,
  keyboard_arrow_left: MuIcons.KeyboardArrowLeft,
  keyboard_arrow_right: MuIcons.KeyboardArrowRight,
  keyboard_arrow_up: MuIcons.KeyboardArrowUpOutlined,
  link: LinkIcon,
  linkOff: LinkOffIcon,
  local_phone: PhoneOutlinedIcon,
  lock_unclosed: MuIcons.LockOpen,
  lock: MuIcons.Lock,
  mail: MuIcons.MailOutline,
  maximize_icon: MuIcons.Maximize,
  money: MoneyOutlinedIcon,
  more_vert: MuIcons.MoreVert,
  notifications_none: MuIcons.NotificationsNoneOutlined,
  payments: PaymentsOutlinedIcon,
  perm_identity: MuIcons.PermIdentityOutlined,
  pix_outlined: PixOutlinedIcon,
  pix: PixIcon,
  print_outlined: MuIcons.PrintOutlined,
  publish: MuIcons.PublishOutlined,
  qr_code: QRCodeOutlineIcon,
  receipt_long: ReceiptLongOutlinedIcon,
  receipt_outlined: MuIcons.ReceiptOutlined,
  refresh: MuIcons.RefreshOutlined,
  remove: MuIcons.Remove,
  request_quote: RequestQuoteOutlinedIcon,
  rule: RuleIcon,
  save_alt: MuIcons.SaveAltOutlined,
  search: MuIcons.SearchOutlined,
  settings: MuIcons.SettingsOutlined,
  share: ShareIcon,
  subtitles: SubtitlesOutlinedIcon,
  trash: DeleteOutlineIcon,
  tune: MuIcons.TuneOutlined,
  visibility_off: MuIcons.VisibilityOffOutlined,
  visibility: MuIcons.VisibilityOutlined,
  vpn_key: VpnKeyOutlinedIcon,
  warning: MuIcons.Warning,
  warning_outlined: WarningAmberOutlinedIcon,
}

const optionsOfCharIcons = {
  brl: 'R$',
  percentage: '%',
}
